import SEO from '@/components/base/SEO';
import Breadcrumb from '@/components/base/Breadcrumb';

const breadcrumb = [
  { label: 'Accueil', to: '/' },
  { label: 'Contact' },
];

export default function Contact() {
  return (
    <>
      <SEO
        title="Contact | DFPRO Hérault — 09 80 80 22 42"
        description="Contactez DFPRO Hérault pour un devis gratuit de réparation de baie coulissante, volet roulant ou vitrage dans l'Hérault. Intervention 24-48h, 7j/7."
        canonicalUrl="https://heraultroulettesbaiesvitrees.fr/contact/"
      />

      {/* Hero */}
      <section className="relative pt-24 pb-12 md:pt-28 md:pb-16 overflow-hidden">
        <img
          src="/images/dfpro-contact-hero.jpg"
          alt="Contact DFPRO Hérault"
          className="absolute inset-0 w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-primary-500/75"></div>
        <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-6">
          <Breadcrumb items={breadcrumb} light />
          <h1 className="text-2xl md:text-3xl font-heading font-bold text-white mt-4">
            Contactez DFPRO Hérault
          </h1>
          <p className="text-[#DCE8F2] text-base mt-3 font-body">
            Un problème de menuiserie ? Appelez-nous ou remplissez le formulaire ci-dessous pour un devis gratuit.
          </p>
        </div>
      </section>

      {/* Contact info + Reassurance */}
      <section className="py-12 md:py-16 bg-background-50">
        <div className="max-w-5xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {/* Téléphone */}
            <div className="bg-white rounded-lg border border-background-200 p-6 text-center hover:border-accent-300 transition-colors duration-300">
              <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-50 text-accent-500 mx-auto mb-4">
                <i className="ri-phone-line text-xl"></i>
              </span>
              <h3 className="font-heading font-semibold text-sm text-primary-500 mb-2">
                Téléphone
              </h3>
              <a
                href="tel:+33980802242"
                className="text-foreground-500 font-label font-bold text-base hover:text-accent-500 transition-colors duration-200"
              >
                09 80 80 22 42
              </a>
              <p className="text-xs text-secondary-400 font-body mt-1">
                Appel gratuit
              </p>
            </div>

            {/* Email */}
            <div className="bg-white rounded-lg border border-background-200 p-6 text-center hover:border-accent-300 transition-colors duration-300">
              <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-50 text-accent-500 mx-auto mb-4">
                <i className="ri-mail-line text-xl"></i>
              </span>
              <h3 className="font-heading font-semibold text-sm text-primary-500 mb-2">
                Email
              </h3>
              <a
                href="mailto:herault@dfpro.fr"
                className="text-foreground-500 font-label font-bold text-sm hover:text-accent-500 transition-colors duration-200 break-all"
              >
                herault@dfpro.fr
              </a>
              <p className="text-xs text-secondary-400 font-body mt-1">
                Réponse sous 2h
              </p>
            </div>

            {/* Horaires */}
            <div className="bg-white rounded-lg border border-background-200 p-6 text-center hover:border-accent-300 transition-colors duration-300">
              <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-50 text-accent-500 mx-auto mb-4">
                <i className="ri-time-line text-xl"></i>
              </span>
              <h3 className="font-heading font-semibold text-sm text-primary-500 mb-2">
                Horaires
              </h3>
              <p className="text-foreground-500 font-label font-bold text-sm">
                7j/7 — 8h à 20h
              </p>
              <p className="text-xs text-secondary-400 font-body mt-1">
                Même le dimanche
              </p>
            </div>

            {/* Zone */}
            <div className="bg-white rounded-lg border border-background-200 p-6 text-center hover:border-accent-300 transition-colors duration-300">
              <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-50 text-accent-500 mx-auto mb-4">
                <i className="ri-map-pin-line text-xl"></i>
              </span>
              <h3 className="font-heading font-semibold text-sm text-primary-500 mb-2">
                Zone d'intervention
              </h3>
              <p className="text-foreground-500 font-label font-bold text-sm">
                Hérault
              </p>
              <p className="text-xs text-secondary-400 font-body mt-1">
                Montpellier, littoral &amp; arrière-pays
              </p>
            </div>
          </div>

          {/* Trust section */}
          <div className="mt-10 bg-white rounded-lg border border-background-200 p-6 md:p-8 flex flex-col md:flex-row items-center gap-6">
            <div className="flex-shrink-0">
              <span className="w-14 h-14 flex items-center justify-center rounded-full bg-accent-50 text-accent-500">
                <i className="ri-shield-star-fill text-2xl"></i>
              </span>
            </div>
            <div className="text-center md:text-left">
              <h3 className="font-heading font-semibold text-base text-primary-500 mb-2">
                Pourquoi nous faire confiance ?
              </h3>
              <p className="text-secondary-500 font-body text-sm leading-relaxed">
                Devis gratuit et sans engagement. Intervention sous 24 à 48h dans tout l&apos;Hérault, garantie 10 ans sur toutes nos réparations. Nos techniciens sont formés aux menuiseries Technal, Sepalumic, Schüco et à la motorisation Somfy.
              </p>
            </div>
            <a
              href="tel:+33980802242"
              className="btn-call text-sm px-6 py-3 whitespace-nowrap flex-shrink-0"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-line text-sm"></i>
              </span>
              Appeler maintenant
            </a>
          </div>
        </div>
      </section>
    </>
  );
}